export interface ApiKey {
  id: string;
  name: string;
  masked: string;
  createdAt: string;
  lastUsedAt: string | null;
}

export interface Webhook {
  id: string;
  url: string;
  events: string[];
  active: boolean;
  lastDelivery: string | null;
}

export interface VoiceModel {
  id: string;
  name: string;
  gender: string;
  languages: string[];
  style: string;
}

// viewer/supervisor exist only where core has org_invitations or member_grants on.
export type TeamRole = "owner" | "member" | "viewer" | "supervisor";
export interface TeamMember {
  id: string; name: string; email: string; role: TeamRole; status?: string; permissions?: string[]; allowedVoices?: string[];
  /** Null/undefined (never configured) means every WhatsApp number; a saved list restricts. */
  allowedWhatsAppInstances?: string[] | null;
  /** Org membership version; the access editor sends it back as expected_version. */
  version?: number | null;
  resourceScope?: unknown;
}

/** Owner view of an R3 invitation. The token fields come back once, on create or resend. */
export interface OwnerInvitation {
  id: string;
  email: string;
  role_id: string;
  permissions: string[];
  resource_scope: unknown;
  status: string;
  created_at: string | null;
  expires_at: string | null;
  delivery: { state: string | null; attempts: number };
  accept_token?: string | null;
  accept_url?: string | null;
}

export const WEBHOOK_EVENTS = [
  "call.completed", "call.failed", "batch.completed", "callback.created", "wallet.low_balance",
] as const;

export const ROLE_OPTIONS: { value: TeamRole; label: string }[] = [
  { value: "owner", label: "Owner" },
  { value: "member", label: "Member" },
];

export const TIMEZONE_OPTIONS = [
  { value: "Asia/Kolkata", label: "Asia/Kolkata (IST)" },
  { value: "Asia/Dubai", label: "Asia/Dubai (GST)" },
  { value: "Europe/London", label: "Europe/London" },
  { value: "America/New_York", label: "America/New_York" },
  { value: "UTC", label: "UTC" },
];
